export default __webpack_public_path__ + "f712ec687399fc740ae1a907d11eab23.png";